import { useMemo } from "react";

import { Dialog } from "@/design-system/components/Dialog/Dialog";
import useAccountMetadata from "@/hooks/useAccountMetadata";
import {} from "@/account/api/company";
import useUsers from "@/hooks/useUsers";
import { UpdateCompanyInfoForm } from "../UpdateCompanyInfoForm/UpdateCompanyInfoForm";

export function RequiredAccountInfoCollectionModal() {
  const accountMetadata = useAccountMetadata();
  const users = useUsers();

  const open = useMemo(() => {
    if (!accountMetadata.loaded || users.loading) return false;

    if (users.currentUser?.role !== "admin") return false;

    return !accountMetadata.companyDetails?.name;
  }, [accountMetadata, users.currentUser?.role, users.loading]);

  return (
    <Dialog open={open} title="Account information required">
      <p className="text-textSubtle mb-4 text-sm">
        Please update your organization name to finish your account setup. You
        can edit this under "Settings" &gt; "Team" if you need to make future
        changes.
      </p>
      <UpdateCompanyInfoForm />
    </Dialog>
  );
}
